module.exports = "/_next/static/images/piggy-monotone-9c1fa1e7a5b85666d93239914d82323c.svg";